/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Manager_Question_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No results for ‘{query}’." |
*
* @param {Manager_Question_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_no_results = /** @type {((inputs: Manager_Question_No_ResultsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_No_ResultsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Geen resultaten voor ‘${i?.query}’.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Aucun résultat pour « ${i?.query} ».`)
	return /** @type {LocalizedString} */ (`No results for ‘${i?.query}’.`)
});